module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "141",
      "height": "139",
      "viewBox": "0 0 141 139",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.1619 22.5964C35.1619 22.5964 56.3207 38.6793 88.4874 8.60716C117.054 -18.0992 140.38 24.0375 140.543 44.216C140.755 70.3549 111.976 91.2702 125.942 108.439C139.908 125.607 98.2452 153.958 75.7909 129.422C47.8584 98.9006 40.2912 123.7 24.3698 123.7C12.9429 123.7 -10.5178 95.26 5.32494 74.1018C18.6564 56.2974 11.3857 50.3885 7.8647 44.216C2.78566 35.3138 14.8474 11.1508 35.1619 22.5964Z",
      "fill": "#F6F5F5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.7725 31.0336L58.7109 25.4522C56.2127 25.0428 53.8556 26.7361 53.4463 29.2343L41.6648 101.132C41.2555 103.63 42.9488 105.987 45.447 106.397L79.5086 111.978C82.0068 112.387 84.3638 110.694 84.7732 108.196L96.5546 36.2982C96.964 33.8 95.2707 31.443 92.7725 31.0336Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.64 33.0604L59.1133 27.7305C57.4478 27.4576 55.8764 28.5865 55.6035 30.2519L44.0332 100.861C43.7603 102.526 44.8892 104.098 46.5547 104.371L79.0814 109.701C80.7469 109.974 82.3183 108.845 82.5912 107.179L94.1614 36.5702C94.4343 34.9047 93.3055 33.3333 91.64 33.0604Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.1467 62.3898C63.4127 60.7521 62.94 59.3127 62.0908 59.1748C61.2416 59.0368 60.3376 60.2526 60.0715 61.8902C59.8055 63.5279 60.2782 64.9673 61.1274 65.1052C61.9766 65.2432 62.8807 64.0274 63.1467 62.3898Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80.8507 65.2958C81.1194 63.6419 80.6488 62.1893 79.7996 62.0513C78.9504 61.9134 78.0442 63.1423 77.7756 64.7963C77.5069 66.4502 77.9775 67.9028 78.8266 68.0408C79.6758 68.1787 80.582 66.9498 80.8507 65.2958Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.5726 77.9797C75.5108 77.9816 75.4494 77.9709 75.3919 77.9482C75.3345 77.9255 75.2823 77.8913 75.2385 77.8478L74.5788 77.1924C73.5204 76.1441 72.147 75.4726 70.6697 75.2811C69.1924 75.0896 67.6931 75.3887 66.4024 76.1325L65.5974 76.598C65.5456 76.6279 65.4885 76.6473 65.4292 76.6551C65.37 76.663 65.3097 76.6591 65.252 76.6436C65.1943 76.6282 65.1401 76.6015 65.0927 76.5652C65.0452 76.5288 65.0054 76.4835 64.9755 76.4317C64.9456 76.38 64.9261 76.3229 64.9183 76.2636C64.9105 76.2044 64.9144 76.1441 64.9298 76.0864C64.9452 76.0287 64.9719 75.9745 65.0083 75.9271C65.0446 75.8796 65.09 75.8398 65.1417 75.8099L65.9468 75.3445C67.4106 74.5009 69.1111 74.1616 70.7866 74.3787C72.4621 74.5959 74.0198 75.3576 75.2202 76.5465L75.8799 77.2019C75.9431 77.2646 75.9864 77.3445 76.0046 77.4316C76.0229 77.5187 76.0151 77.6092 75.9824 77.692C75.9497 77.7748 75.8934 77.8461 75.8206 77.8973C75.7478 77.9484 75.6615 77.977 75.5726 77.9796L75.5726 77.9797Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "103.477",
      "y": "112.744",
      "width": "23.9389",
      "height": "23.9389",
      "rx": "11.9694",
      "transform": "rotate(180 103.477 112.744)",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "86.3828",
      "y": "96.7866",
      "width": "1.61213",
      "height": "12.897",
      "rx": "0.812574",
      "transform": "rotate(-45 86.3828 96.7866)",
      "fill": "white",
      "stroke": "white"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "86.3828",
      "y": "104.768",
      "width": "12.897",
      "height": "1.61213",
      "rx": "0.812574",
      "transform": "rotate(-45 86.3828 104.768)",
      "fill": "white",
      "stroke": "white"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b76bc0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/NoDeviceIcon.vue
// module id = 688
// module chunks = 0